import React, { Dispatch, SetStateAction } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Avatar, Badge, Box, IconButton, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import avatar from '../../assets/img/default-avatar.png';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector } from 'react-redux';

interface Props {
  userName: string;
  isCollapsed: boolean;
  userProfileMugshot: string;
  setIsCollapsed: Dispatch<SetStateAction<boolean>>;
  onNotificationsIconClick: () => void;
}

export const SidebarUserSection = ({
  isCollapsed,
  setIsCollapsed,
  userName,
  userProfileMugshot,
  onNotificationsIconClick,
}: Props) => {
  const portalNotifications = useSelector((state: any) => state.portalNotifications);

  const handeleNotificationIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onNotificationsIconClick();
  };

  return (
    <ListItem
      onClick={() => setIsCollapsed(prev => !prev)}
      disableGutters
      className="userSectionListItem"
      secondaryAction={
        <IconButton className="notificationIconButton" onClick={handeleNotificationIconClick} size="small">
          <Badge badgeContent={portalNotifications.unreadCount} color="error" max={99}>
            <NotificationsIcon sx={{ color: 'white' }} fontSize="small" />
          </Badge>
        </IconButton>
      }
    >
      <ListItemAvatar className="userAvatar">
        <Avatar alt="user logo" src={userProfileMugshot || avatar} className="userAvatarImage" />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1" className="userNameText">
              {userName}
            </Typography>
            {isCollapsed ? <ExpandLess /> : <ExpandMore />}
          </Box>
        }
      />
    </ListItem>
  );
};
